export const NAVIGATION_TEXT = {
  nl: {
    home: "Home",
    inventoryManagement: "Voorraad beheer",
    planning: "Planning",
    history: "Historie",
    weekOrders: "Weekorders",
    palletStock: "Palletvoorraad",
    packagingStock: "Fustvoorraad",
    orderData: "Order Data",
    fieldManagement: "Percelen beheer",
    crateManagement: "Kisten beheer",
    woodenLabels: "Houten labels",
    users: "Gebruikers",
    assignToOrder: "Aan order koppelen",
  },
  en: {
    home: "Home",
    inventoryManagement: "Inventory management",
    planning: "Planning",
    history: "History",
    weekOrders: "Week orders",
    palletStock: "Pallet stock",
    packagingStock: "Packaging stock",
    orderData: "Order data",
    fieldManagement: "Field management",
    crateManagement: "Crate management",
    woodenLabels: "Wooden labels",
    users: "Users",
    assignToOrder: "Assign to order",
  },
  pl: {
    home: "Strona główna",
    inventoryManagement: "Zarządzanie zapasami",
    planning: "Planowanie",
    history: "Historia",
    weekOrders: "Zamówienia tygodniowe",
    palletStock: "Zapas palet",
    packagingStock: "Zapas opakowań",
    orderData: "Dane zamówień",
    fieldManagement: "Zarządzanie polami",
    crateManagement: "Zarządzanie skrzynkami",
    woodenLabels: "Drewniane etykiety",
    users: "Użytkownicy",
    assignToOrder: "Przypisz do zamówienia",
  },
};

export const getNavigationText = (language) =>
  NAVIGATION_TEXT[language] || NAVIGATION_TEXT.nl;
